export default __webpack_public_path__ + "static/media/logos-europeus.9f45e284.png";